export default {
    InternalReturnRefund: {
        OrderNo: 'Refund order/sales Order No.',
        document: 'Return logistics number',
        Return: 'Return order source',
        nickname: "Buyer's nickname",
        Returned: 'Returner',
        Tripartite: 'Third-party return time',
        refund: 'New return and refund order',
        form: {
            Internal: 'Internal return Order No.',
            Third: 'Third-party return Order No.',
            party: 'Customer Order No.',
            order: 'CSG Order No.',
            Return: 'Return order type',
            type: 'Return type',
            source: 'Return order source',
            refund: 'Return and refund reason',
            comments: "Buyer's remarks",
            service: 'Customer service remarks',
            quantity: 'Return quantity',
            Total: 'Total refund amount to be paid by buyer',
            method: 'Settlement method',
            Receiving: 'Receiving warehouse',
            logistics: 'Return logistics information',
            nickname: "Buyer's nickname",
            Returned: 'Returner',
            mobile: "Returner's mobile number",
            address: "Returner's address",
            store: 'Store',
            channel: 'Sales Channel',
            returntime: 'Third-party return time',
            creation: 'Internal Creation Time',
            completion: 'Return completion time',
        },
    }
};
